import React, { useContext } from "react";
import { Actionable, Card, Image, Stack, Text } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import styles from "./AnywhereV2.module.css";
import { SearchBoxContext } from "../SearchBoxContext/index.js";
import { ANYWHERE_LOCATION } from "../../utils/constants.js";
const AnywhereV2 = ({ add }) => {
    const { searchType, i18n, onTrackSBExperimentCustomGoal } = useContext(SearchBoxContext);
    if (searchType === "MULTISTOP") {
        return null;
    }
    const handleSelection = () => {
        onTrackSBExperimentCustomGoal({ name: "flights_web_cat_fly_anywhere_illustration", customGoal: 2 });
        add({ ...ANYWHERE_LOCATION, code: i18n.trans(t("flights_search_destination_list_item_anywhere")) });
    };
    return (React.createElement(Stack, { direction: "column", className: styles.wrapper, gap: 0 },
        React.createElement(Stack.Item, null,
            React.createElement(Card, { className: styles.card },
                React.createElement(Stack, { direction: "row", alignItems: "end", gap: 4 },
                    React.createElement(Stack.Item, null,
                        React.createElement(Image, { className: styles.illustration, asset: {
                                setName: "illustrations-traveller",
                                assetName: "FlightsExploreAnywhereSearchBox"
                            }, contentMode: "fit" })),
                    React.createElement(Stack.Item, { grow: true },
                        React.createElement(Stack, { direction: "column", gap: 1, className: styles.text },
                            React.createElement(Text, { variant: "strong_2", tagName: "strong" }, i18n.trans(t("flights_fa_search_card_title"))),
                            React.createElement(Text, { variant: "body_2", tagName: "text", color: "neutral_alt" }, i18n.trans(t("flights_fa_search_card_subtitle"))),
                            React.createElement(Actionable, { onClick: handleSelection, className: styles.link },
                                React.createElement(Text, { variant: "body_2", tagName: "text", color: "action" }, i18n.trans(t("flights_fa_search_card_cta")))))))))));
};
export default AnywhereV2;
